export default __webpack_public_path__ + "static/media/6.35c9b0d1.jpg";